"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationOptionsModel = void 0;
const validator_1 = require("@leavy/validator");
class PaginationOptionsModel {
    constructor() {
        this.page = 0;
        this.perPage = 10;
    }
}
__decorate([
    validator_1.IsInt(),
    validator_1.Min(0),
    __metadata("design:type", Number)
], PaginationOptionsModel.prototype, "page", void 0);
__decorate([
    validator_1.IsInt(),
    validator_1.Min(1),
    __metadata("design:type", Number)
], PaginationOptionsModel.prototype, "perPage", void 0);
exports.PaginationOptionsModel = PaginationOptionsModel;
//# sourceMappingURL=PaginationOptionsModel.js.map